import { useSelector } from 'react-redux';
import { readStoredAuthToken } from '@/entities/session/model/authStorage';
import { selectIsAuthenticated } from '@/entities/session/model/sessionSelectors';
/**
 * 判断是否应发起需要登录态的查询：已认证，或本地仍持有令牌（会话恢复中）。
 * 会话恢复期间 redux 状态尚未就绪，但本地令牌存在，允许查询可避免
 * 已登录用户刷新页面时闪现「请先登录」；登出后令牌与 redux 状态同时清理，
 * 查询随之停用，页面直接进入未登录提示，不再发起注定失败的请求。
 * 直接使用 react-redux 的 useSelector 并配合结构化选择器，
 * 避免会话实体反向依赖 app 层的 store hooks。
 * @returns 是否允许发起需要登录态的查询。
 */
export function useAuthedQueryEnabled() {
    const isAuthenticated = useSelector(selectIsAuthenticated);
    return isAuthenticated || Boolean(readStoredAuthToken());
}
